import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";
import { useEffect } from "react";
import { FileSignature, LayoutDashboard, ScrollText, FileText, LogOut, ShieldCheck, BookOpenCheck, Users, FileSearch, Euro, ShieldAlert, Settings } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/clients", label: "Clients", icon: Users, testid: "admin-nav-clients" },
  { to: "/admin/scans", label: "Scans", icon: FileSearch, testid: "admin-nav-scans" },
  { to: "/admin/billing", label: "Facturation", icon: Euro, testid: "admin-nav-billing" },
  { to: "/admin/compliance", label: "Conformité & RGPD", icon: ShieldAlert, testid: "admin-nav-compliance" },
  { to: "/admin/exploitation", label: "Exploitation", icon: Settings, testid: "admin-nav-exploitation" },
  { to: "/admin/nda", label: "NDA", icon: FileSignature, testid: "admin-nav-nda" },
  { to: "/admin/audit", label: "Journal d'audit", icon: ScrollText, testid: "admin-nav-audit" },
  { to: "/admin/corpus", label: "Corpus légal", icon: BookOpenCheck, testid: "admin-nav-corpus" },
  { to: "/admin/docs", label: "Documentation", icon: FileText, testid: "admin-nav-docs" },
];

export default function AdminAppShell() {
  const { admin, ready, logout } = useAdminAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (ready && !admin) nav("/admin/login", { replace: true });
  }, [ready, admin, nav]);

  if (!ready || !admin) {
    return <div className="min-h-screen bg-[#0b1220] text-slate-300 flex items-center justify-center">Chargement…</div>;
  }

  return (
    <div className="min-h-screen bg-[#0b1220] text-slate-100" data-testid="admin-shell">
      <aside className="fixed inset-y-0 left-0 w-64 border-r border-slate-800 bg-[#0f172a] flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-slate-800">
          <ShieldCheck className="w-5 h-5 text-emerald-400 mr-2" />
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-500">EmpCo</p>
            <p className="text-sm font-semibold">Console Admin</p>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition ${
                  isActive
                    ? "bg-[#1F5A99]/20 text-white border-l-2 border-[#4CAF6A]"
                    : "text-slate-400 hover:text-white hover:bg-slate-800/60"
                }`
              }
            >
              <n.icon className="w-4 h-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800 text-xs">
          <p className="text-slate-500">Connecté en tant que</p>
          <p className="font-mono text-slate-200 truncate" data-testid="admin-current-email">{admin.email}</p>
          <button
            onClick={async () => { await logout(); nav("/admin/login"); }}
            className="mt-3 w-full flex items-center justify-center gap-2 py-2 rounded-md bg-slate-800 hover:bg-slate-700 text-slate-200 text-xs"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-3.5 h-3.5" /> Déconnexion
          </button>
        </div>
      </aside>
      <main className="pl-64">
        <div className="max-w-7xl mx-auto px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
